import { getRelativeDate } from './date-generator'

export const getToday = (
  params: { timeZone?: string; format?: 'timestamp' | 'date' | Intl.DateTimeFormatOptions } = {}
): Date | number | string => {
  return getRelativeDate({
    ...params
  })
}
